export default __webpack_public_path__ + "static/media/twitter.76965a30.svg";